import { ThemeProvider, themes, FontsLite } from '@kawaui/theme'
import { useAuth } from '@narf/auth'
import { useUnauth } from '@narf/unauth'

import React from 'react'

import { GlobalStyle } from 'styles/global'
import { getIsPrivalia, getIsVeepeePurpleTheme } from 'utils/methods'

type Props = {
  children: React.ReactNode
}

export const Theme = ({ children }: Props) => {
  const { isPrivalia: isPrivaliaUnauth } = useUnauth() || {}
  const { siteId } = useAuth() || {}
  const isPrivalia = siteId ? getIsPrivalia(siteId) : isPrivaliaUnauth
  const veepeTheme = getIsVeepeePurpleTheme(siteId) ? themes.purple : themes.default

  const theme = isPrivalia ? themes.privalia : veepeTheme
  return (
    <ThemeProvider theme={theme}>
      <FontsLite />
      <GlobalStyle />
      {children}
    </ThemeProvider>
  )
}
